import { combineReducers } from "redux";
import Mainreducer from "./Mainreducer";
import RoleReducer from "./RoleReducer";
import UserRoleReducer from "./UserRoleReducer";
import CategoryReducer from "./CategoryReducer";
import CategoryTreeReducer from "./CategoryTreeReducer";
import SubCategoryReducer from "./SubCategoryReducer";
import PodcasterReducer from "./PodcasterReducer";
import PolicyReducer from "./PolicyReducer";
import ReportReducer from "./ReportReducer";
import ProfileReducer from "./ProfileReducer";
import AuthReducer from "./AuthReducer";
import PermissionReducer from "./PermissionReducer";
import sidebarReducer from "./sidebarReducer";
import SettingsReducer from "./SettingsReducer";
import AlbumsReducer from "./AlbumsReducer";
import TracksReducer from "./TracksReducer";
import AudioLibrariesReducer from "./AudioLibrariesReducer";
import CustomersReducer from "./CustomersReducer"; 
import SubscriptionsReducer from "./SubscriptionsReducer";
import TransactionsReducer from "./TransactionsReducer";
import DashboardReducer from "./DashboardReducer";
import PaymentCallbackReducer from "./PaymentCallback";
import VipBannersReducer from "./VipBannersReducer";
import AudioAdsReducer from "./InternalAudioAdsReducer";
import EmailNotifications from "./EmailNotificationsReducer";
import PushNotificationsReducer from "./PushNotificationsReducer";
import AdCampaignsReducer from "./AdCampaignsReducer";
import userNotifications from "./UserNotificationsReducer";
import NotificationCampaignReducer from "./NotificationCampaignsReducer";
import ContentReportsReducer from "./ContentReportsReducer";
import context from "react-bootstrap/esm/AccordionContext";

export default combineReducers({
  Mainreducer,
  RoleReducer,
  UserRoleReducer,
  category: CategoryReducer,
  categoryTree: CategoryTreeReducer,
  subCategory: SubCategoryReducer,
  podcasters: PodcasterReducer,
  Sidebar: sidebarReducer,
  albums: AlbumsReducer,
  tracks: TracksReducer,
  customers: CustomersReducer,
  audios: AudioLibrariesReducer,
  settings: SettingsReducer,
  subscriptions: SubscriptionsReducer,
  transactions: TransactionsReducer,
  dashboard: DashboardReducer,
  PolicyReducer,
  ReportReducer,
  ProfileReducer,
  AuthReducer,
  PermissionReducer,
  paymentCallback: PaymentCallbackReducer,
  vipBanners: VipBannersReducer,
  audioAds: AudioAdsReducer,
  emailNotifications: EmailNotifications,
  pushNotifications: PushNotificationsReducer,
  adCampaigns: AdCampaignsReducer,
  userNotifications,
  notificationCampaigns:NotificationCampaignReducer,
  contentReports:ContentReportsReducer
})
